export default {
  strict: true,
  namespaced: true,
  state: {
    idToken: null,
    isAuthenticatedInPinMode: false,
    pinModeName: "",
  },
  getters: {
    isAuthenticated: (state) => !!state.idToken,
    id: (state) => (state.idToken ? state.idToken.payload.sub : ""),
    name: (state) => (state.isAuthenticatedInPinMode ? state.pinModeName : state.idToken ? state.idToken.payload.name : ""),
    email: (state) => (state.idToken ? state.idToken.payload.email : ""),
  },
  mutations: {
    setIdToken: (state, payload) => (state.idToken = payload),
    setIsAuthenticatedInPinMode: (state, payload) => (state.isAuthenticatedInPinMode = payload),
    setPinModeName: (state, payload) => (state.pinModeName = payload),
  },
  actions: {
    setIdToken: (context, payload) => {
      if (payload === context.state.idToken) return;
      if (payload && context.state.idToken && payload.jwtToken === context.state.idToken.jwtToken) return;
      context.commit("setIdToken", payload);
    },
    initPinMode: ({ commit }, session) => {
      if (session) {
        commit("setIsAuthenticatedInPinMode", !!session.isAuthenticatedInPinMode);
        commit("setPinModeName", session.pinModeName);
      } else {
        commit("setIsAuthenticatedInPinMode", false);
        commit("setPinModeName", "");
      }
    },
  },
};
